/**
	* @package Alchemists HTML
	*
	* Template Scripts
	* Created by Dan Fisher
*/

(function($) {
	var items = new Array(),
		errors = new Array(),
		onComplete = function() {},
		current = 0;

	var jpreOptions = {
		splashVPos: '35%',
		loaderVPos: '75%',
		splashID: '#jpreContent',
		showSplash: true,
		showPercentage: true,
		autoClose: true,
		closeBtnText: 'Start!',
		onetimeLoad: false,
		debugMode: false,
		splashFunction: function() {}
	}

	//cookie
	var getCookie = function() {
		if( jpreOptions.onetimeLoad ) {
			var cookies = document.cookie.split('; ');
			for (var i = 0, parts; (parts = cookies[i] && cookies[i].split('=')); i++) {
				if ((parts.shift()) === "jpreLoader") {
					return (parts.join('='));
				}
			}
			return false;
		} else {
			return false;
		}

	}
	var setCookie = function(expires) {
		if( jpreOptions.onetimeLoad ) {
			var exdate = new Date();
			exdate.setDate( exdate.getDate() + expires );
			var c_value = ((expires==null) ? "" : "expires=" + exdate.toUTCString());
			document.cookie="jpreLoader=loaded; " + c_value;
		}
	}

	//create jpreLoader UI
	var createContainer = function() {

		jOverlay = $('<div></div>')
		.attr('id', 'jpreOverlay')
		.css({
			position: "fixed",
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			zIndex: 9999999
		})
		.appendTo('body');

		if(jpreOptions.showSplash) {
			jContent = $('<div></div>')
			.attr('id', 'jpreSlide')
			.appendTo(jOverlay);

			var conWidth = $(window).width() - $(jContent).width();
			$(jContent).css({
				position: "absolute",
				top: jpreOptions.splashVPos,
				left: Math.round((50 / $(window).width()) * conWidth) + '%'
			});
			$(jContent).html($(jpreOptions.splashID).wrap('<div/>').parent().html());
			$(jpreOptions.splashID).remove();
			jpreOptions.splashFunction()
		}

		jLoader = $('<div></div>')
		.attr('id', 'jpreLoader')
		.appendTo(jOverlay);

		var posWidth = $(window).width() - $(jLoader).width();
		$(jLoader).css({
			position: 'absolute',
			top: jpreOptions.loaderVPos,
			left: Math.round((50 / $(window).width()) * posWidth) + '%'
		});

		jBar = $('<div></div>')
		.attr('id', 'jpreBar')
		.css({
			width: '0%',
			height: '100%'
		})
		.appendTo(jLoader);

		if(jpreOptions.showPercentage) {
			jPer = $('<div></div>')
			.attr('id', 'jprePercentage')
			.css({
				position: 'relative',
				height: '100%'
			})
			.appendTo(jLoader)
			.html('0%');
		}
		if( !jpreOptions.autoclose ) {
			jButton = $('<div></div>')
			.attr('id', 'jpreButton')
			.on('click', function() {
				loadComplete();
			})
			.css({
				position: 'relative',
				height: '100%'
			})
			.appendTo(jLoader)
			.text(jpreOptions.closeBtnText)
			.hide();
		}
	}

	//get all images from css and <img> tag
	var getImages = function(element) {
		$(element).find('*:not(script)').each(function() {
			var url = "";

			if ($(this).css('background-image').indexOf('none') == -1 && $(this).css('background-image').indexOf('-gradient') == -1 && $(this).css('background-image').indexOf('svg') == -1) {
				url = $(this).css('background-image');
				if(url.indexOf('url') != -1) {
					var temp = url.match(/url\((.*?)\)/);
					url = temp[1].replace(/\"/g, '');
				}
			} else if ($(this).get(0).nodeName.toLowerCase() == 'img' && typeof($(this).attr('src')) != 'undefined') {
				url = $(this).attr('src');
			}

			if (url.length > 0) {
				items.push(url);
			}
		});
	}

	//create preloaded image
	var preloading = function() {
		for (var i = 0; i < items.length; i++) {
			if(loadImg(items[i]));
		}
	}
	var loadImg = function(url) {
		var imgLoad = new Image();
		$(imgLoad)
        .on('load',
		    function() {
                completeLoading();
            }
        )
        .on('error',
            function() {
                errors.push($(this).attr('src'));
                completeLoading();
            }
        )
		.attr('src', url);
	}

	//update progress bar once image loaded
	var completeLoading = function() {
		current++;

		var per = Math.round((current / items.length) * 100);
		$(jBar).stop().animate({
			width: per + '%'
		}, 500, 'linear');

		if(jpreOptions.showPercentage) {
			$(jPer).text(per+"%");
		}

		//if all images loaded
		if(current >= items.length) {
			current = items.length;
			setCookie();	//create cookie

			if(jpreOptions.showPercentage) {
				$(jPer).text("100%");
			}

			//fire debug mode
			if (jpreOptions.debugMode) {
				var error = debug();
			}


			//max progress bar
			$(jBar).stop().animate({
				width: '100%'
			}, 500, 'linear', function() {
				//autoclose on
				if( jpreOptions.autoClose )
					loadComplete();
				else
					$(jButton).fadeIn(1000);
			});
		}
	}

	//triggered when all images are loaded
	var loadComplete = function() {
		$(jOverlay).fadeOut(800, function() {
			$(jOverlay).remove();
			onComplete();	//callback function
		});
	}

	//debug mode
	var debug = function() {
		if(errors.length > 0) {
			var str = 'ERROR - IMAGE FILES MISSING!!!\n\r'
			str	+= errors.length + ' image files cound not be found. \n\r';
			str += 'Please check your image paths and filenames:\n\r';
			for (var i = 0; i < errors.length; i++) {
				str += '- ' + errors[i] + '\n\r';
			}
			return true;
		} else {
			return false;
		}
	}

	$.fn.jpreLoader = function(options, callback) {
        if(options) {
            $.extend(jpreOptions, options );
        }
		if(typeof callback == 'function') {
			onComplete = callback;
		}

		//show preloader once JS loaded
		$('body').css({
			'display': 'block'
		});

		return this.each(function() {
			if( !(getCookie()) ) {
				createContainer();
				getImages(this);
				preloading();
			}
			else {	//onetime load / cookie is set
				$(jpreOptions.splashID).remove();
				onComplete();
			}
		});
    };

})(jQuery);


;(function($){
	"use strict";

	$('body:not(.page-loader-disable)').jpreLoader({
		showSplash: false,
		loaderVPos: "50%",
	});

	$.fn.exists = function () {
		return this.length > 0;
	};

	/* ----------------------------------------------------------- */
	/*  Predefined Variables
	/* ----------------------------------------------------------- */
	var $template_var = $('body').data('template');
	var $color_primary = '#ffdc11';
	var $main_nav     = $('.main-nav');
	var $slick_featured_slider   = $('.posts--slider-featured');
	var $slick_featured_carousel = $('.featured-carousel');
	var $slick_video_carousel = $('.video-carousel');
	var $slick_product = $('.product__slider');
	var $slick_product_soccer = $('.product__slider-soccer');
	var $mp_single = $('.mp_single-img');
	var $mp_gallery = $('.mp_gallery');
	var $mp_iframe = $('.mp_iframe');

	if ( $template_var == 'template-soccer' ) {
		$color_primary = '#1892ed';
	} else if ( $template_var == 'template-esports') {
		$color_primary = '#00ff5b';
	} else if ( $template_var == 'template-football' ) {
		$color_primary = '#f92552';
	}

	function setCookie(cname, expireTime) {
	    var secs = Number(expireTime);
	    if (isNaN(secs)) {
	        secs = 5;
	    }
	    var now = new Date();
	    var exp = new Date(now.getTime() + secs*1000);
	    var status = '';
	    document.cookie = cname +'=m3skalina; expires='+exp.toUTCString()+';Path=/';
	    if (document.cookie && document.cookie.indexOf('ExpirationCookieTest=1') != -1) {
	        status = 'Cookie successfully set. Expiration in '+secs+' seconds';
	    } else {
	        status = 'Cookie NOT set. Please make sure your browser is accepting cookies';
	    }


	}
	function getCookie(cname) {
	    var name = cname + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var ca = decodedCookie.split(';');
	    for(var i = 0; i <ca.length; i++) {
	      var c = ca[i];
	      while (c.charAt(0) == ' ') {
	        c = c.substring(1);
	      }
	      if (c.indexOf(name) == 0) {
	        return c.substring(name.length, c.length);
	      }
	    }
	    return "";
	}

	var Core = {

		initialize: function() {

			this.headerNav();

            this.disableRightClick();

			this.SlickCarousel();

			this.MagnificPopup();

			this.miscScripts();

      		this.goTop();

			this.CookieBar();

			this.MobileBanner();


		},

		MobileBanner: function() {

			new SmartBanner({
				daysHidden: 15,   // days to hide banner after close button is clicked (defaults to 15)
				daysReminder: 90, // days to hide banner after "VIEW" button is clicked (defaults to 90)
				appStoreLanguage: 'us', // language code for the App Store (defaults to user's browser language)
				title: 'Formula Car Setup',
				author: 'F1 Game Setup',
				button: 'VIEW',
				store: {
					android: 'In Google Play',
				},
				price: {
					android: 'FREE',
				}
				// , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
				// , icon: '' // full path to icon image if not using website icon image
				// , force: 'ios' // Uncomment for platform emulation
			});

		},

		CookieBar: function() {

			var options = {
				title: 'Cookies',
				message: 'Cookies enable you to personalize your experience on our site, tell us which parts of our website people have visited, help us measure the effectiveness of ads and web searchs.',
				link: '/privacy-policy',
				delay: '2500',
				expires: '180',
				cookieTypes: [
		        {
		            type: 'Site Preferences',
		            value: 'preferences',
		            description: 'These are cookies that are related to your site preferences, e.g. remembering your username, site colours, etc.'
		        },
		    ],
			};

			$('body').ihavecookies(options);

		},

        disableRightClick: function() {

            document.addEventListener("contextmenu", function(event){
            event.preventDefault();
            }, false);

        },

		goTop: function() {
			$(window).scroll(function() {
				if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
					$('#goTopBtn').fadeIn(500);    // Fade in the arrow
					$('.navbar').fadeIn(500);    // Fade in the arrow
				} else {
					$('#goTopBtn').fadeOut(100);   // Else fade out the arrow
					$('.navbar').fadeOut(100);   // Else fade out the arrow
				}
				if ($(this).scrollTop() >= 600) {
					$('#footer-ads-mob-001').addClass('d-block');
				} else {
					$('#footer-ads-mob-001').removeClass('d-block');   // Else fade out the arrow
				}
			});
			$('#goTopBtn').click(function() {      // When arrow is clicked
				$('body,html').animate({
					scrollTop : 0                       // Scroll to top of body
				}, 500);
			});
		},

		SlickCarousel: function() {

			if ( $slick_video_carousel.exists() ) {

				$slick_video_carousel.slick({
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					autoplay: true,
					autoplaySpeed: 5000,
					rows: 0,

					responsive: [
						{
							breakpoint: 992,
							settings: {
								arrows: false,
								slidesToShow: 2,
								infinite: true
							}
						},
						{
							breakpoint: 768,
							settings: {
								arrows: false,
								slidesToShow: 2,
								infinite: false
							}
						},
						{
							breakpoint: 480,
							settings: {
								arrows: true,
								slidesToShow: 1,
								infinite: false
							}
						}
					]
				});

			}

			if ( $slick_product.exists() ) {


					$slick_product.slick({
						slidesToShow: 1,
						arrows: false,
						dots: true,
						rows: 0,
					});

			}

			if ( $slick_product_soccer.exists() ) {

				$slick_product_soccer.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					rows: 0,
					asNavFor: '.product__slider-thumbs'
				});
				$('.product__slider-thumbs').slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					asNavFor: $slick_product_soccer,
					focusOnSelect: true,
					vertical: true,
					rows: 0,
				});
			}

		},

		headerNav: function() {

			$('#social-helmets-close-btn').on('click',function(){
				console.log('prova');
				$('.social-share-box-helmets').removeClass('active');
				$('.overlay-share-helmets').removeClass('overlay-share-active');
			});
			$('#profile-change').on('click',function(){
				$(".overlay-share-helmets").addClass('overlay-share-active');
				$(".social-share-box-helmets").addClass('active');
			});

			if ( $main_nav.exists() ) {

				var $top_nav     = $('.nav-account');
				var $top_nav_li  = $('.nav-account > li');
				var $social      = $('.social-links--main-nav');
				var $info_nav_li = $('.info-block--header > li');
				var $info_nav_li_onclick = $('.js-info-block__item--onclick');
				var $wrapper     = $('.site-wrapper');
				var $nav_list    = $('.main-nav__list');
				var $nav_list_li = $('.main-nav__list > li');
				var $toggle_btn  = $('#header-mobile__toggle');
				var $pushy_btn   = $('.pushy-panel__toggle');

				// Clone Search Form
				var $header_search_form = $('.header-search-form').clone();
				$('#header-mobile').append($header_search_form);

				// Clone Shopping Cart to Mobile Menu
				var $shop_cart = $('.info-block__item--shopping-cart > .info-block__link-wrapper').clone();
				$shop_cart.appendTo($nav_list).wrap('<li class="main-nav__item--shopping-cart"></li>');

				// Add arrow and class if Top Bar menu ite has submenu
				$top_nav_li.has('ul').addClass('has-children').prepend('<span class="main-nav__toggle"></span>');

				// Clone Top Bar menu to Main Menu
				if ( $top_nav.exists() ) {
					var children = $top_nav.children().clone();
					$nav_list.append(children);
				}

				// Clone Header Logo to Mobile Menu
				var $logo_mobile = $('.header-mobile__logo').clone();
				$nav_list.prepend($logo_mobile);
				$logo_mobile.prepend('<span class="main-nav__back"></span>');

				// Clone Header Info to Mobile Menu
				var header_info1 = $('.info-block__item--contact-primary').clone();
				var header_info2 = $('.info-block__item--contact-secondary').clone();
				$nav_list.append(header_info1).append(header_info2);

				// Clone Social Links to Main Menu
				if ( $social.exists() ) {
					var social_li = $social.children().clone();
					var social_li_new = social_li.contents().unwrap();
					social_li_new.appendTo($nav_list).wrapAll('<li class="main-nav__item--social-links"></li>');
				}

				// Add arrow and class if Info Header Nav has submenu
				$info_nav_li.has('ul').addClass('has-children');

				if ( $info_nav_li_onclick.exists() ){
					$info_nav_li_onclick.prepend('<span class="info-block__menu-icon"></span>');
					$info_nav_li_onclick.on('click', '.info-block__menu-icon', function() {
						$(this).toggleClass('active');
					});
				}

				// Mobile Menu Toggle
				$toggle_btn.on('click', function(){
					$wrapper.toggleClass('site-wrapper--has-overlay');
				});

				$('.site-overlay, .main-nav__back').on('click', function(){
					$wrapper.toggleClass('site-wrapper--has-overlay');
				});

				// Pushy Panel Toggle
				$pushy_btn.on('click', function(e){
					e.preventDefault();
					$wrapper.toggleClass('site-wrapper--has-overlay-pushy');
				});

				$('.site-overlay, .pushy-panel__back-btn').on('click', function(e){
					e.preventDefault();
					$wrapper.removeClass('site-wrapper--has-overlay-pushy site-wrapper--has-overlay');
				});

				// Add toggle button and class if menu has submenu
				$nav_list_li.has('.main-nav__sub').addClass('has-children').prepend('<span class="main-nav__toggle"></span>');
				$nav_list_li.has('.main-nav__megamenu').addClass('has-children').prepend('<span class="main-nav__toggle"></span>');

				$('.main-nav__toggle').on('click', function(){
					$(this).toggleClass('main-nav__toggle--rotate')
					.parent().siblings().children().removeClass('main-nav__toggle--rotate');

					$(".main-nav__sub, .main-nav__megamenu").not($(this).siblings('.main-nav__sub, .main-nav__megamenu')).slideUp('normal');
					$(this).siblings('.main-nav__sub').slideToggle('normal');
					$(this).siblings('.main-nav__megamenu').slideToggle('normal');
				});

				// Add toggle button and class if submenu has sub-submenu
				$('.main-nav__list > li > ul > li').has('.main-nav__sub-2').addClass('has-children').prepend('<span class="main-nav__toggle-2"></span>');
				$('.main-nav__list > li > ul > li > ul > li').has('.main-nav__sub-3').addClass('has-children').prepend('<span class="main-nav__toggle-2"></span>');

				$('.main-nav__toggle-2').on('click', function(){
					$(this).toggleClass('main-nav__toggle--rotate');
					$(this).siblings('.main-nav__sub-2').slideToggle('normal');
					$(this).siblings('.main-nav__sub-3').slideToggle('normal');
				});

				// Mobile Search
				$('#header-mobile__search-icon').on('click', function(){
					$(this).toggleClass('header-mobile__search-icon--close');
					$('.header-mobile').toggleClass('header-mobile--expanded');
				});
			}
		},

		MagnificPopup: function () {

			if ($mp_single.exists()) {
				// Single Image
				$('.mp_single-img').magnificPopup({
					type: 'image',
					removalDelay: 300,

					gallery: {
						enabled: false
					},
					mainClass: 'mfp-fade',
					autoFocusLast: false,

				});
			}

			if ($mp_gallery.exists()) {
				// Multiple Images (gallery)
				$('.mp_gallery').magnificPopup({
					type: 'image',
					removalDelay: 300,

					gallery: {
						enabled: true
					},
					mainClass: 'mfp-fade',
					autoFocusLast: false,

				});
			}

			if ($mp_iframe.exists()) {
				// Iframe (video, maps)
				$('.mp_iframe').magnificPopup({
					type: 'iframe',
					removalDelay: 300,
					mainClass: 'mfp-fade',
					autoFocusLast: false,

					patterns: {
						youtube: {
							index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

							id: 'v=', // String that splits URL in a two parts, second part should be %id%
							// Or null - full URL will be returned
							// Or a function that should return %id%, for example:
							// id: function(url) { return 'parsed id'; }

							src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
						},
						vimeo: {
							index: 'vimeo.com/',
							id: '/',
							src: '//player.vimeo.com/video/%id%?autoplay=1'
						},
						twitch: {
							index: 'twitch.tv/',
							id: 'videos/',
							src: '//player.twitch.tv/?autoplay=false&video=v%id%'
						},
						gmaps: {
							index: '//maps.google.',
							src: '%id%&output=embed'
						}
					},

					srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".

				});
			}
		},

		miscScripts: function() {
			// Tooltips
			// $('[data-toggle="tooltip"]').tooltip();

			[].slice.call( document.querySelectorAll( 'select.cs-select' ) ).forEach( function(el) {
				new SelectFx(el);
			} );

			// Duotone effect
			$('.effect-duotone').prepend('<div class="effect-duotone__layer"><div class="effect-duotone__layer-inner"></div></div>');

		},

	};

	$(document).on('ready', function() {
		Core.initialize();
	});

})(jQuery);
